// extracted by mini-css-extract-plugin
export default {"card":"Loans_card__k0jPC","title":"Loans_title__SxlsC","head1":"Loans_head1__Rl7iu","head2":"Loans_head2__jeSnG","head3":"Loans_head3__Vb8D7"};